module.exports = __webpack_public_path__ + "img/milva-icon.2a1fabf3.svg";